module.exports = __webpack_public_path__ + "static/media/logoOnDark.dc7859a5.svg";